import React from 'react';
import {checkError} from 'root/DataFunctions/BaseDataFns'

export default class DesiTeacherChildrenPanel extends React.Component
{
	static get defaultProps() 
	{
		var v =
		{
			role: 'desiteacher',
			targetForNextPEPRequired: true, 
			previousPEPResultRequired: true 
		} ;

	  	return v ;
	}
	  
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 0 ;

    	// Create a state item here for all items on the form  (Using their id )
		this.state = {loading: true, val: this.props.value, data: this.props.data, mode: 'edit' };
	}

	UNSAFE_componentWillMount()
	{
		this.getdata() ;
	}

	getUrlPathForRole(role)
	{
		var path = "/desipersons/" ;
		
		switch ( role )
		{
		case 'desiteacher':
			path = "/desipersons/" ;
			break ;
		case 'carer':
			path = "/carers/" ;
			break ;
		case 'socialworker':
			path = "/socialworkers/" ;
			break ;
		case 'esw':
			path = "/esws/" ;
			break ;
		case 'edpsych':
			path = "/edpsychs/" ;
			break ;
		case 'cas':
			path = "/cas/" ;
			break ;
		default:
			path = "/desipersons/" ;
			break ;
		}
		
		return path ;
	}
	
	getdata( )
	{
		// Globals are defined in the globals.js class
		var root = Globals.APIFolder ;
		
		var url = root + this.getUrlPathForRole(this.props.role)+this.props.user_id+"/children"
		
    	$.ajax({
    		  type: 'GET',
    		  url: url,
    		  data: { },
    		  success:(data)=>{
    			
    			  if ( checkError(data))
				  {
				  		if ( data.data == null )
				  		{
	    					this.setState({  loading: false , data: [] });				  			  			
				  		}
				  		else
				  		{
							  const child_count = data.data.length ;

							  if ( this.props.setChildCount !== undefined )
							  {
								  this.props.setChildCount ( child_count ) ;
							  }

	    					this.setState({  loading: false , data: data.data });				  			  			
				  		}
				  }
    		  },
    		  error:(jqXHR, textStatus, error)=>{

					bootbox.alert({ 
					  size: "large",
					  title: "The operation failed",
					  message: error.stack + '\n' + jqXHR.responseText + '<br><br>' + getErrorObject().stack, 
					  callback: function()
					  { 
					  }
					})	    		  	
		  		}

    		});
	}
	
	textSpan ( value )
	{
		return React.createElement ( 'span', { key: this.keyCount++, style:{ fontWeight: 'bold', color: 'rgb(93, 155, 208)', 
    fontSize: 'large'}}, value ) ;
	}

	textSpanHeading ( value )
	{
		return React.createElement ( 'span', { key: this.keyCount++, style:{ fontWeight: 'bold'}}, value ) ;
	}
	
	childHeading()
	{
		var colList=[] ;

		var style = {
			    paddingTop: '5px',
			    paddingBottom: '5px',
			    borderBottomStyle: 'solid',
			    borderBottomColor: 'rgb(186, 193, 216)',
			    borderBottomWidth: 'thin',
			    fontWeight: 'bold'
		}

		colList.push ( React.createElement('div', {key: this.keyCount++, className: 'col-md-3'}, "First Name" )) ;
		colList.push ( React.createElement('div', {key: this.keyCount++, className: 'col-md-3'}, "Surname")) ;
		colList.push ( React.createElement('div', {key: this.keyCount++,className: 'col-md-3'}, "Year" )) ;
		colList.push ( React.createElement('div', {key: this.keyCount++,className: 'col-md-3'}, "" )) ;

		return React.createElement ( 'div',  {  className: 'row', key: this.keyCount++, style: style }, colList) ;
	}	

	childRows ( childRecord )
	{
		var lineList=[] ;

		var style = {
			    paddingTop: '5px',
			    paddingBottom: '5px',
			    borderBottomStyle: 'solid',
			    borderBottomColor: '#dddddd',
			    borderBottomWidth: 'thin'
		}

		var styleNoContent = {
			    paddingTop: '5px',
			    paddingBottom: '5px'
		}
		
		if ( this.state.data.length == 0 )
		{
		    lineList.push ( React.createElement('div', {  key: this.keyCount++, className: 'row', style: styleNoContent },
		    React.createElement('div', {key: this.keyCount++, className: 'col-md-12'}, "No children"))) ;
		}
		else
		{
			lineList.push ( this.childHeading());

			for (var x in this.state.data ) 
			{
				var record = this.state.data[x] ;

				var colList=[] ;

				colList.push ( React.createElement('div', {key: this.keyCount++, className: 'col-md-3'}, record.firstname )) ;
				colList.push ( React.createElement('div', {key: this.keyCount++, className: 'col-md-3'}, record.surname)) ;
				colList.push ( React.createElement('div', {key: this.keyCount++, className: 'col-md-3'}, record.year_name )) ;
				colList.push ( React.createElement('div', {key: this.keyCount++, className: 'col-md-3'}, '' )) ;

				lineList.push ( React.createElement('div', {  key: this.keyCount++, style: style, className: 'row'}, colList ) ) ;
			}					
		}

		return lineList ;
	}
	
	panelCollection ()
	{ 
        var lineList=[];
        
        lineList.push (React.createElement('div', {  key: this.keyCount++, className: 'panel-heading'}, "Allocated Children"));
        
        lineList.push (React.createElement('div', {  key: this.keyCount++, className: 'panel-body'}, this.childRows()));

        return lineList ;
	}
	
	renderedComponent()
	{
    	return React.createElement ('div', {  key: this.props.keyValue, className: 'panel panel-default' }, this.panelCollection());
	}
	
    render() 
    {
    	this.keyCount = 0 ;
    	
    	if ( this.state.loading == true )
    	{
	        return React.createElement('div', { key: this.keyCount++, className: ''}, "LOADING...");		    		
    	}
    	else
    	{
        	return this.renderedComponent() ;    	
    	}
    }
};
